import ProductSuggestion from '../_patterns/01-components/product-suggestion/product-suggestion';
import { dispatchCustomEvent } from './utils';

const init = () => {
  window.swaProductSuggestion = [];
  document
    .querySelectorAll('.js-swa-product-suggestion')
    .forEach(carouselElement => {
      new ProductSuggestion(carouselElement).init();
    });

  window.productSuggestionClass = ProductSuggestion;
  dispatchCustomEvent('swaProductSuggestionsInitialized');
};

if (document.querySelector('.js-swa-wishlist-page') || document.querySelector('.js-swa-wishlist-empty-page')) {
  window.onload = () => {
    init();
  };
}
